module.exports = __webpack_public_path__ + "img/ultrawhite.98938b08.png";